angular.module "avant.trackingPixel"
.directive "trackingPixel", ["$window", "$q", ($window, $q) ->
  return (
    restrict: "AE"
    scope:
      sourcex: '='
    template: '<iframe height="1" width="1" frameborder="0" ng-src="{{sourcex}}"></iframe>'
  )
]
